import React, { useEffect, useState } from 'react'
import styles from "../Corpus/corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import MillUnitCorpus from './MillUnitCorpus'
import "../../App.css"
import UnitStyles from "./MilUnit.module.css"
import CustomSelect from '../../Components/CustomSelect'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'

export default function MilUnit() {
    const [milName, setMilName] = useState("")
    const [milUnitNumber, setMilUnitNumber] = useState("")
    const [milUnitCloseNumber, setMilUnitCloseNumber] = useState("")
    const [unitFullName, setUnitFullName] = useState(milUnitNumber + milName)
    const [milUnits, setMilUnits] = useState([])
    const [change, setChange] = useState(null)
    const [corpuses, setCorpuses] = useState([])
    const [corpus, setCorpus] = useState("")
    const [isMillUnitShown, setMillUNitShown] = useState(false)
    const [corpusNum, setCorpusNum] = useState()
    const [loading, setLoading] = useState(false)
    const [clear, setClear] = useState(false)
    const [search, setSearch] = useState("")

    useEffect(() => {
        (async() => {
            const milunits = await axiosInstance.get('admin/milunits')
            if(milunits.status){
                setMilUnits(milunits.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        if(unitFullName){
            const [number, name] = unitFullName.split(" ")
            setMilUnitNumber(number)
            setMilName(name)
        }
    }, [unitFullName])

    useEffect(() => {
           (async() => {
               const corpuses = await axiosInstance.get('admin/corpuses')
               if(corpuses.status){
                   setCorpuses(corpuses.data.data)

               }
           })()
       }, [])


    const submitHandler = async () => {
        if(!milUnitCloseNumber){
            toast.error("Զորամասի համարը պարտադիր է");
            return;
        }
        if(!milName){
            toast.error("Զորամասի անվանումը պարտադիր է");
            return;
        }
        if(!milUnitNumber){
            toast.error("Զորամասի փակ համարը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.post('admin/milunit', {unit: {unit_number: milUnitNumber, unit_name: milName, unit_corpus: corpus.trim() ? corpus : null, unit_close_number: milUnitCloseNumber}})
        if(res.data.status){
            setChange("")
            setMilUnitCloseNumber("")
            setCorpus("")
            setUnitFullName("")
            setMilUnits([...milUnits, res.data.data])
            toast.success("Զորամասը հաջողությամբ ավելացվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

    const changeCorpus = async (el) => {
        setChange(el)
        setMilName(el.unit_name)
        setMilUnitNumber(el.unit_number)
        setMilUnitCloseNumber(el.unit_close_number)
        setCorpus(el.unit_corpus)
        setUnitFullName(el.unit_number + " " +  el.unit_name)
    }

    const deleteMilUnit = async (el) => {
        const res = await axiosInstance.delete(`admin/milunit/${el._id}:${el.unit_corpus}`)
        if(res.data.status){
            setMilUnits(p => {
                return p.filter(item => item._id !== el._id)
            })
            toast.success("Զորամասը հաջողությամբ ջնջվեց");
        }
    }

    const changeHandler = async () => {
        if(!milUnitCloseNumber){
            toast.error("Զորամասի համարը պարտադիր է");
            return;
        }
        if(!milName){
            toast.error("Զորամասի անվանումը պարտադիր է");
            return;
        }
        if(!milUnitNumber){
            toast.error("Զորամասի փակ համարը պարտադիր է");
            return;
        }
        setLoading(true)
        const res = await axiosInstance.put(`admin/milunit/${change._id}`, {unit_name: milName, unit_number: milUnitNumber, unit_corpus: corpus.trim() ? corpus : null, unit_close_number: milUnitCloseNumber})
        if(res.data.status){
            setChange(null)
            setMilUnits(p => {
                let index = milUnits.findIndex(el => el._id === change._id)
                const newCorpuses = [...milUnits]
                newCorpuses[index] = {...change, unit_name: milName, unit_number: milUnitNumber, unit_corpus: corpus, unit_close_number: milUnitCloseNumber}
                return newCorpuses
            })
            setMilName("")
            setMilUnitNumber("")
            setMilUnitCloseNumber("")
            setCorpus("")
            setUnitFullName("")
            toast.success("Զորամասը հաջողությամբ փոփոխվեց");
            setClear(true)
            setTimeout(() => {setClear(false)}, 100)
        }
        setLoading(false)
    }

  return (
    <div className={styles["corpus-main-div"]}>
        <div className={`${styles["corpus-container"]} w-1/3`}>
            <h2>Լրացրեք զորամասի տվյալները</h2>
             <div>
                <label htmlFor="corpusNumber">Զորամասի փակ համար / Զորամասի անվանում</label>
                <input type="text" id="corpusNumber" value={unitFullName} onChange={(e) => setUnitFullName(e.target.value)} />
            </div>
            <div>
                <label htmlFor="corpusNumber">Զորամասի բաց համար</label>
                <input type="text" id="corpusNumber" value={milUnitCloseNumber} onChange={(e) => setMilUnitCloseNumber(e.target.value)} />
            </div>
            <div>
                <CustomSelect 
                    defaultValueForInput={corpus ? corpuses.find(el => el._id === corpus)?.corpus_number + " " + corpuses.find(el => el._id === corpus)?.corpus_name : ''}
                    options={corpuses.map((el,i) => <option key={i} value={el._id}>{el.corpus_number + " " + el.corpus_name}</option>)}
                    callback={setCorpus}
                    label="Ընտրել կորպուսը"
                    clear={clear}
                />
            </div>
           
            <button className={`confirm-btn mt-[20px]`} disabled={loading} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
        </div>
        <div className={UnitStyles["corpus-list"]}>
            <div className='relative'>
                <h2>Զորամասեր</h2>
                <input type="text" placeholder='Փնտրել...' className="absolute border border-black/40 p-1 rounded-md top-0 left-4" onChange={(e) => setSearch(e.target.value)}/>
            </div>
                {!search ?corpuses.map((el, index) => {
                    return (
                        <li key={index} className={UnitStyles["corpus-list-items"]}>
                            <p className='text-center cursor-pointer' onClick={() => {setCorpusNum(el._id);setMillUNitShown(!isMillUnitShown)}}>{el?.corpus_number + " " + el?.corpus_name}</p>
                            {isMillUnitShown && corpusNum === el._id  && <MillUnitCorpus millUnits={milUnits} corpusNumber={el?._id} deleteMilUnit={deleteMilUnit} changeCorpus={changeCorpus} />}
                        </li>
                    )
                }) : <ol className='border-t border-black/40'>
                                  <li className={styles["corpus-list-item"]}>
                                      <p className='per3 start'>Զորամաս</p>
                                      <p className='per3 end'>Ղեկավարման կոճակներ</p>
                                  </li>
                                  {milUnits?.filter(el => el.unit_number.includes(search) || el.unit_name.includes(search) || el.unit_close_number.includes(search)).map((el, index) => {
                                      return <li key={index} className={styles["corpus-list-item"]}>
                                              <p className='per3 start'>{el?.unit_number + " " + el.unit_name}  ({el?.unit_close_number})</p>
                                              <div className='per3 end'>
                                                  <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => changeCorpus(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                                  <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => deleteMilUnit(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                                              </div>
                                          </li>
                                  })}
                                  
                              </ol>}
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
